/* eslint-disable array-callback-return */
import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import _ from "lodash";

import { renderDate } from "../../../constant/helper/helper";
import Card from "../../../component/card/Card";
import Starter from "../../../component/Starter";
import { helperFunction } from "../../../constant/helper";
import {
  attendanceActions,
  locationActions,
  ruleActions
} from "../../../redux/actions";
import { AttendanceTypes } from "../../../redux/type/type";
import TopInput from "./TopInput";
import ShiftList from "./ShiftList";
import isEmpty from "../../../validation/isEmpty";

const initialState = {
  Filter: "",
  toDate: "",
  fromDate: "",
  weeklyOff: "",
  updateDate: "",
  locationId: "",
  updateShift: "",
  updateLocation: ""
};

const AllShift = () => {
  const componentRef = useRef();

  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [values, setValues] = useState(initialState);
  const [allRules, setAllRules] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [dateDifference, setDateDifference] = useState(0);
  const [dateArrayState, setDateArrayState] = useState([]);
  const [sheetShiftData, setSheetShiftData] = useState([]);

  const { locations } = useSelector((state) => state.location);
  const { currentUser } = useSelector((state) => state.auth);
  const { activeNow } = useSelector((state) => state.rule);

  const {
    toDate,
    fromDate,
    locationId,
    shiftSheetData,
    attendanceError,
    attendanceLoading,
    attendanceResponse
  } = useSelector((state) => state.attendance);

  useEffect(() => {
    if (attendanceError) {
      helperFunction.toastHelper("error", attendanceError);
    }
    if (attendanceResponse) {
      helperFunction.toastHelper("success", attendanceResponse);
    }
  }, [attendanceError, attendanceResponse]);

  useEffect(() => {
    if (!isEmpty(shiftSheetData)) {
      setSheetShiftData(
        shiftSheetData.map((dataInSheet) => {
          const dailyShiftArray = [];
          const dailyShift = [];
          dataInSheet.shiftListData.map((date) => {
            return dailyShiftArray.push({
              date: moment(date.date).format("DD/MM/yyyy"),
              shiftCode: date.shiftCode,
              shiftType: date.shiftType
            });
          });

          const obj = _.mapKeys(dailyShiftArray, "date");
          dateArrayState.forEach((dateValue) => {
            // console.log(obj);
            const shiftCode = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].shiftCode;
            const shiftType = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].shiftType;

            return dailyShift.push({
              date: dateValue,
              shiftCode: shiftCode,
              shiftType: shiftType
            });
          });
          return {
            employeeId: dataInSheet._id,
            workerId: dataInSheet.workerId,
            workerFullName:
              dataInSheet.workerFirstName +
              " " +
              dataInSheet.workerSurname,
            shiftListData: dailyShift
          };
        })
      );
    } else {
      setSheetShiftData([]);
    }
  }, [shiftSheetData]);

  useEffect(() => {
    const ruleArray = [];
    if (activeNow !== null) {
      activeNow.map((singleRule) => {
        ruleArray.push({
          _id: singleRule._id,
          shiftIn: singleRule.shiftIn,
          shiftOut: singleRule.shiftOut,
          shiftCode: singleRule.shiftCode,
          shiftType: singleRule.shiftType,
          locationName: singleRule.locationName,
          locationType: singleRule.locationType
        });
      });
      setAllRules(ruleArray);
    } else {
      setAllRules([]);
    }
  }, [activeNow]);

  useEffect(() => {
    setValues({
      ...values,
      fromDate,
      toDate,
      locationId
    });
  }, [fromDate, toDate, locationId]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    // dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
    if (name === "updateLocation") {
      dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
    }
  };

  const onUpdateShift = (e) => {
    e.preventDefault();
    dispatch(attendanceActions.setAttendanceLoading(true));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    dispatch(attendanceActions.updateShiftAction(values, loginType));
  };

  const fetchAllShift = (e) => {
    e.preventDefault();
    const { fromDate, toDate, locationId } = values;
    if (fromDate === "" || toDate === "") {
      const errorData = {
        data: {
          message: "From Date,To Date or Location is not selected"
        },
        status: 400
      };
      return dispatch({
        type: AttendanceTypes.ATTENDANCE_GET_ERRORS,
        payload: errorData
      });
    } else {
      const diffTime = Math.abs(
        new Date(toDate) - new Date(fromDate)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDateDifference(diffDays);
      const dateArray = renderDate(values);
      setDateArrayState(dateArray);
      dispatch(attendanceActions.setAttendanceLoading(true));
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());
      dispatch(
        attendanceActions.getAllShiftActions(
          fromDate,
          toDate,
          locationId,
          loginType
        )
      );
    }
  };

  return (
    <Starter
      topBarTitle="Shift Changes"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">All Shifts</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          allRules={allRules}
          onSubmit={fetchAllShift}
          currentUser={currentUser}
          loading={attendanceLoading}
          onChange={handleInputChange}
          onUpdateShift={onUpdateShift}
          dateDifference={dateDifference}
          allLocations={
            typeof allLocations !== "undefined" &&
            allLocations.length > 0
              ? allLocations
              : []
          }
        />
        <ShiftList
          values={values}
          shiftListData={sheetShiftData}
          excelRef={componentRef}
          loading={attendanceLoading}
          dateArrayState={dateArrayState}
          dateDifference={dateDifference}
        />
      </Card>
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${fromDate}_${toDate}`}
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default AllShift;
